import AureminSymbol from '../ui/AureminSymbol.jsx';
import AureminWordmark from '../ui/AureminWordmark.jsx';
import TrexMark from '../ui/TrexMark.jsx';
import { signIn, signOut } from './session.js';

// The screen outside the application, composed as Nexus composes its own so the two read as one
// family: the symbol over the wordmark with the application's line beneath it, an eyebrow, a
// two-line heading and the Microsoft button - all centred on the warm ground with no card
// (TX-US-0018). The bar is not here: the bar means "in".
//
// The four phases are App's; this component only says what each looks like. The slot beneath
// the heading has a fixed minimum height, so the heading does not move as the slot changes from
// a progress bar to a button to a message.

export default function SignInWall({ phase, me, message }) {
  return (
    <main className="wall">
      <section className="wall-card" aria-labelledby="wall-heading">
        <div className="wall-brand">
          <AureminSymbol size={48} />
          <AureminWordmark height={20} />
        </div>

        <div className="wall-lockup">
          <TrexMark size={112} />
          <span className="wall-title">T-REX</span>
        </div>

        <span className="eyebrow">TRADE RISK E<b>X</b>POSURE</span>
        <h1 id="wall-heading">
          Every deal.
          <br />
          Every exposure.
        </h1>

        <div className="wall-slot">
          {phase === 'loading' && (
            <div className="wall-progress" role="progressbar" aria-label="Signing in" />
          )}

          {phase === 'signed-out' && (
            <button type="button" className="primary microsoft" onClick={signIn}>
              <span className="ms-mark" aria-hidden="true"><i /><i /><i /><i /></span>
              Continue with Microsoft
              <span aria-hidden="true">↗</span>
            </button>
          )}

          {phase === 'pending' && (
            <>
              <p>
                Your account <strong>{me.email}</strong> is registered but does not yet have access.
                An administrator must grant it before you can use T-REX.
              </p>
              <button type="button" className="secondary" onClick={signOut}>Sign out</button>
            </>
          )}

          {phase === 'error' && (
            <>
              <p className="wall-error" role="alert">{message}</p>
              <button type="button" className="secondary" onClick={() => window.location.reload()}>
                Try again
              </button>
            </>
          )}
        </div>

        <span className="wall-note">Access is limited to authorised Auremin users.</span>
      </section>
    </main>
  );
}
